<template>
  <div class="container col-md-12">
    <roe-calc-input-fields
      :inputCategories="inputCategories"
      :calcAction="calcAction"
    >
    </roe-calc-input-fields>
    <br />
    <div v-if="calcData">
      <md-content>
        <md-content class="md-padding">
          <table class="table table-bordered">
            <tr>
              <th>Index</th>
              <th>Database</th>
              <th>Category</th>
              <th>Provision</th>
              <th>General Edits</th>
              <th>Data</th>
            </tr>
            <tr>
              <td>2</td>
              <td>irs_limits</td>
              <td>Compliance Limits</td>
              <td>max_deferral</td>
              <td>
                {{
                  calcData.compliance_limit.max_deferral
                    | currency({ fractionCount: 3 })
                }}
              </td>
              <td>
                {{
                  calcData.compliance_limit.max_deferral
                    | currency({ fractionCount: 3 })
                }}
              </td>
            </tr>
            <tr class="yellow">
              <td>3</td>
              <td>irs_limits</td>
              <td>Compliance Limits</td>
              <td>max_contribution_dc_plan</td>
              <td>
                {{
                  calcData.compliance_limit.max_contribution_dc_plan
                    | currency({ fractionCount: 3 })
                }}
              </td>
              <td>
                {{
                  calcData.compliance_limit.max_contribution_dc_plan
                    | currency({ fractionCount: 3 })
                }}
              </td>
            </tr>
            <tr class="yellow">
              <td>4</td>
              <td>irs_limits</td>
              <td>Compliance Limits</td>
              <td>max_contribution_db_plan</td>
              <td>
                {{
                  calcData.compliance_limit.max_contribution_db_plan
                    | currency({ fractionCount: 3 })
                }}
              </td>
              <td>
                {{
                  calcData.compliance_limit.max_contribution_db_plan
                    | currency({ fractionCount: 3 })
                }}
              </td>
            </tr>
            <tr>
              <td>5</td>
              <td>irs_limits</td>
              <td>Compliance Limits</td>
              <td>max_comp</td>
              <td>
                {{
                  calcData.compliance_limit.max_comp
                    | currency({ fractionCount: 3 })
                }}
              </td>
              <td>
                {{
                  calcData.compliance_limit.max_comp
                    | currency({ fractionCount: 3 })
                }}
              </td>
            </tr>
            <tr>
              <td>6</td>
              <td>irs_limits</td>
              <td>Compliance Limits</td>
              <td>catch_up</td>
              <td>
                {{
                  calcData.compliance_limit.catch_up
                    | currency({ fractionCount: 3 })
                }}
              </td>
              <td>
                {{
                  calcData.compliance_limit.catch_up
                    | currency({ fractionCount: 3 })
                }}
              </td>
            </tr>
            <tr class="yellow">
              <td>7</td>
              <td>irs_limits</td>
              <td>Compliance Limits</td>
              <td>hce_comp</td>
              <td>
                {{
                  calcData.compliance_limit.hce_comp
                    | currency({ fractionCount: 3 })
                }}
              </td>
              <td>
                {{
                  calcData.compliance_limit.hce_comp
                    | currency({ fractionCount: 3 })
                }}
              </td>
            </tr>
            <tr class="yellow">
              <td>8</td>
              <td>irs_limits</td>
              <td>Compliance Limits</td>
              <td>key_ee_comp_officer</td>
              <td>
                {{
                  calcData.compliance_limit.key_ee_comp_officer
                    | currency({ fractionCount: 3 })
                }}
              </td>
              <td>
                {{
                  calcData.compliance_limit.key_ee_comp_officer
                    | currency({ fractionCount: 3 })
                }}
              </td>
            </tr>
            <tr class="yellow">
              <td>9</td>
              <td>irs_limits</td>
              <td>Compliance Limits</td>
              <td>one_percent_owner_comp</td>
              <td>
                {{
                  calcData.compliance_limit.one_percent_owner_comp
                    | currency({ fractionCount: 3 })
                }}
              </td>
              <td>
                {{
                  calcData.compliance_limit.one_percent_owner_comp
                    | currency({ fractionCount: 3 })
                }}
              </td>
            </tr>
            <tr class="yellow">
              <td>10</td>
              <td>irs_limits</td>
              <td>Compliance Limits</td>
              <td>social_security_wage_base</td>
              <td>
                {{
                  calcData.compliance_limit.social_security_wage_base
                    | currency({ fractionCount: 3 })
                }}
              </td>
              <td>
                {{
                  calcData.compliance_limit.social_security_wage_base
                    | currency({ fractionCount: 3 })
                }}
              </td>
            </tr>
            <tr class="yellow">
              <td>11</td>
              <td>fbi_plan_record</td>
              <td>Plan Basic Data</td>
              <td>ein_plan_code</td>
              <td>Form 5500 code</td>
              <td>{{ calcData.plan_basic_data.ein_plan_code }}</td>
            </tr>
            <tr class="yellow">
              <td>12</td>
              <td>fbi_plan_record</td>
              <td>Plan Basic Data</td>
              <td>plan_number_three_digit</td>
              <td>Form 5500 code</td>
              <td>{{ calcData.plan_basic_data.plan_number_three_digit }}</td>
            </tr>
            <tr>
              <td>13</td>
              <td>fbi_plan_record</td>
              <td>Plan Basic Data</td>
              <td>data_as_of_date</td>
              <td>
                Month end for Plan Design info as well as Participant Info
              </td>
              <td>
                {{ calcData.plan_basic_data.date | dateFormat("MM/D/YYYY") }}
              </td>
            </tr>
            <tr>
              <td>14</td>
              <td>fbi_plan_record</td>
              <td>Plan Basic Data</td>
              <td>Plan Year End</td>
              <td>End of Plan Year..must be one of the 12 month end dates</td>
              <td>
                {{
                  calcData.plan_basic_data.plan_end_date | dateFormat("MM/D")
                }}
              </td>
            </tr>
            <tr>
              <td>15</td>
              <td>roe_savings_plan_design</td>
              <td>Auto Enrollment</td>
              <td>Auto-Enrollment</td>
              <td>No, New Hires, All Employees</td>
              <td>{{ calcData.auto_enrollment.plan }}</td>
            </tr>
            <tr>
              <td>16</td>
              <td>roe_savings_plan_design</td>
              <td>Auto Enrollment</td>
              <td>Auto-Enrollment Initial Percentage</td>
              <td>1% to 15%</td>
              <td>{{ calcData.auto_enrollment.initial_percent }}%</td>
            </tr>
            <tr>
              <td>17</td>
              <td>roe_savings_plan_design</td>
              <td>Auto Enrollment</td>
              <td>Auto Enrollment Type</td>
              <td>Pre-Tax or Roth</td>
              <td>{{ calcData.auto_enrollment.type }}</td>
            </tr>
            <tr>
              <td>18</td>
              <td>roe_savings_plan_design</td>
              <td>Auto Increase</td>
              <td>Auto Increase Type</td>
              <td>No, Voluntary, Mandatory</td>
              <td>{{ calcData.auto_increase.type }}</td>
            </tr>
            <tr>
              <td>19</td>
              <td>roe_savings_plan_design</td>
              <td>Auto Increase</td>
              <td>Auto Increase Source</td>
              <td>Pre-Tax or Roth</td>
              <td>{{ calcData.auto_increase.source }}</td>
            </tr>
            <tr>
              <td>20</td>
              <td>roe_savings_plan_design</td>
              <td>Auto Increase</td>
              <td>Auto Increase Annual</td>
              <td>1% to 15%</td>
              <td>{{ calcData.auto_increase.annual }}%</td>
            </tr>
            <tr>
              <td>21</td>
              <td>roe_savings_plan_design</td>
              <td>Auto Increase</td>
              <td>Auto Increase Max</td>
              <td>1% to 15%</td>
              <td>{{ calcData.auto_increase.max }}%</td>
            </tr>
            <tr>
              <td>22</td>
              <td>roe_savings_plan_design</td>
              <td>Auto Increase</td>
              <td>Auto Increase Date</td>
              <td>
                Annual change A = 1/1, P = 1st of Plan Year, H = Hire date, E =
                Elig Date
              </td>
              <td>{{ calcData.auto_increase.date_type }}</td>
            </tr>
            <tr>
              <td>23</td>
              <td>roe_savings_plan_design</td>
              <td>Employee Contributions</td>
              <td>Age requirement EE contributions - Yrs</td>
              <td>Between 0 and 21</td>
              <td>
                {{
                  calcData.employee_contribution.req_age_years | numeral("0.2")
                }}
              </td>
            </tr>
            <tr>
              <td>24</td>
              <td>roe_savings_plan_design</td>
              <td>Employee Contributions</td>
              <td>Age requirement EE Contributions - Mos</td>
              <td>Between 0 and 12</td>
              <td>
                {{
                  calcData.employee_contribution.req_age_months | numeral("0.2")
                }}
              </td>
            </tr>
            <tr>
              <td>25</td>
              <td>roe_savings_plan_design</td>
              <td>Employee Contributions</td>
              <td>Service requirement EE contributions - Months</td>
              <td>Between 0 and 12</td>
              <td>
                {{
                  calcData.employee_contribution.req_service_months
                    | numeral("0.2")
                }}
              </td>
            </tr>
            <tr>
              <td>26</td>
              <td>roe_savings_plan_design</td>
              <td>Employee Contributions</td>
              <td>Entry date</td>
              <td>
                Immediate - Monthly - Quarterly - Semi-Annual (Annual not
                allowed)
              </td>
              <td>{{ calcData.employee_contribution.entry_date_type }}</td>
            </tr>
            <tr>
              <td>27</td>
              <td>roe_savings_plan_design</td>
              <td>Employee Contributions</td>
              <td>Excluded Employees</td>
              <td>Only pass eligible employees</td>
              <td>{{ calcData.employee_contribution.excluded_employees }}</td>
            </tr>
            <tr>
              <td>28</td>
              <td>roe_savings_plan_design</td>
              <td>Employee Contributions</td>
              <td>Contribution Pre-Tax</td>
              <td>Yes or No</td>
              <td>{{ calcData.employee_contribution.pre_tax }}</td>
            </tr>
            <tr>
              <td>29</td>
              <td>roe_savings_plan_design</td>
              <td>Employee Contributions</td>
              <td>Contribution Pre-Tax Maximum</td>
              <td>10% to 100%</td>
              <td>{{ calcData.employee_contribution.pre_tax_max }}%</td>
            </tr>
            <tr>
              <td>30</td>
              <td>roe_savings_plan_design</td>
              <td>Employee Contributions</td>
              <td>Contribution Roth</td>
              <td>Yes or No</td>
              <td>{{ calcData.employee_contribution.roth }}</td>
            </tr>
            <tr>
              <td>31</td>
              <td>roe_savings_plan_design</td>
              <td>Employee Contributions</td>
              <td>Contribution Roth Maximum</td>
              <td>10% to 100%</td>
              <td>{{ calcData.employee_contribution.roth_max }}%</td>
            </tr>
            <tr>
              <td>32</td>
              <td>roe_savings_plan_design</td>
              <td>Employee Contributions</td>
              <td>Contribution Post-Tax</td>
              <td>Yes or No</td>
              <td>{{ calcData.employee_contribution.post_tax }}</td>
            </tr>
            <tr>
              <td>33</td>
              <td>roe_savings_plan_design</td>
              <td>Employee Contributions</td>
              <td>Contribution Post-Tax Maximum</td>
              <td>10% to 100%</td>
              <td>{{ calcData.employee_contribution.post_tax_max }}%</td>
            </tr>
            <tr>
              <td>34</td>
              <td>roe_savings_plan_design</td>
              <td>Employee Contributions</td>
              <td>Contribution Combined</td>
              <td>Yes or No</td>
              <td>{{ calcData.employee_contribution.combined }}</td>
            </tr>
            <tr>
              <td>35</td>
              <td>roe_savings_plan_design</td>
              <td>Employee Contributions</td>
              <td>Contribution Combined Maximum</td>
              <td>a least as large as other max but <= 100%</td>
              <td>{{ calcData.employee_contribution.combined_max }}%</td>
            </tr>
            <tr>
              <td>36</td>
              <td>roe_savings_plan_design</td>
              <td>Employee Contributions</td>
              <td>Catch-up</td>
              <td>Yes or No</td>
              <td>{{ calcData.employee_contribution.catch_up }}</td>
            </tr>
            <tr>
              <td>37</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match</td>
              <td>Yes or No</td>
              <td>{{ calcData.employer_match.er_match }}</td>
            </tr>
            <tr>
              <td>38</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Age requirement Years</td>
              <td>Between 0 and 21</td>
              <td>
                {{ calcData.employer_match.req_age_years | numeral("0.2") }}
              </td>
            </tr>
            <tr>
              <td>39</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Age requirement Months</td>
              <td>0 to 12</td>
              <td>
                {{ calcData.employer_match.req_age_months | numeral("0.2") }}
              </td>
            </tr>
            <tr>
              <td>40</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Service requirement Years</td>
              <td>0, 1 or 2</td>
              <td>
                {{ calcData.employer_match.req_service_years | numeral("0.2") }}
              </td>
            </tr>
            <tr>
              <td>41</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Service requirement Months</td>
              <td>0 to 12</td>
              <td>
                {{
                  calcData.employer_match.req_service_months | numeral("0.2")
                }}
              </td>
            </tr>
            <tr>
              <td>42</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Matching Type</td>
              <td>Compensation or Contribution</td>
              <td>{{ calcData.employer_match.type }}</td>
            </tr>
            <tr>
              <td>43</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Vary on YOS</td>
              <td>Yes or No</td>
              <td>{{ calcData.employer_match.yos_vary }}</td>
            </tr>
            <tr>
              <td>44</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Number of Tiers</td>
              <td></td>
              <td>{{ calcData.employer_match.tiers.length }}</td>
            </tr>
            <tr>
              <td>45</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 1 Matching Amount</td>
              <td>0% to 500%</td>
              <td>{{ calcData.employer_match.tiers[0].matching_amount }}%</td>
            </tr>
            <tr>
              <td>46</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 1 Deferral Rate</td>
              <td>0% to 15%</td>
              <td>{{ calcData.employer_match.tiers[0].deferral_rate }}%</td>
            </tr>
            <tr>
              <td>47</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 1 Contribution Amount</td>
              <td>up to $18,500</td>
              <td>
                {{
                  calcData.employer_match.tiers[0].contribution_amount
                    | currency
                }}
              </td>
            </tr>
            <tr>
              <td>48</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 1 YOS Upper Limit</td>
              <td><= 30</td>
              <td>{{ calcData.employer_match.tiers[0].yos_upper_limit }}</td>
            </tr>

            <tr>
              <td>49</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 2 Matching Amount</td>
              <td>0% to 500%</td>
              <td>{{ calcData.employer_match.tiers[1].matching_amount }}%</td>
            </tr>
            <tr>
              <td>50</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 2 Deferral Rate</td>
              <td>0% to 15%</td>
              <td>{{ calcData.employer_match.tiers[1].deferral_rate }}%</td>
            </tr>
            <tr>
              <td>51</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 2 Contribution Amount</td>
              <td>up to $18,500</td>
              <td>
                {{
                  calcData.employer_match.tiers[1].contribution_amount
                    | currency
                }}
              </td>
            </tr>
            <tr>
              <td>52</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 2 YOS Upper Limit</td>
              <td><= 30</td>
              <td>{{ calcData.employer_match.tiers[1].yos_upper_limit }}</td>
            </tr>

            <tr>
              <td>53</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 3 Matching Amount</td>
              <td>0% to 500%</td>
              <td>{{ calcData.employer_match.tiers[2].matching_amount }}%</td>
            </tr>
            <tr>
              <td>54</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 3 Deferral Rate</td>
              <td>0% to 15%</td>
              <td>{{ calcData.employer_match.tiers[2].deferral_rate }}%</td>
            </tr>
            <tr>
              <td>55</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 3 Contribution Amount</td>
              <td>up to $18,500</td>
              <td>
                {{
                  calcData.employer_match.tiers[2].contribution_amount
                    | currency
                }}
              </td>
            </tr>
            <tr>
              <td>56</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 3 YOS Upper Limit</td>
              <td><= 30</td>
              <td>{{ calcData.employer_match.tiers[2].yos_upper_limit }}</td>
            </tr>

            <tr>
              <td>57</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 4 Matching Amount</td>
              <td>0% to 500%</td>
              <td>{{ calcData.employer_match.tiers[3].matching_amount }}%</td>
            </tr>
            <tr>
              <td>58</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 4 Deferral Rate</td>
              <td>0% to 15%</td>
              <td>{{ calcData.employer_match.tiers[3].deferral_rate }}%</td>
            </tr>
            <tr>
              <td>59</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 4 Contribution Amount</td>
              <td>up to $18,500</td>
              <td>
                {{
                  calcData.employer_match.tiers[3].contribution_amount
                    | currency
                }}
              </td>
            </tr>
            <tr>
              <td>60</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 4 YOS Upper Limit</td>
              <td><= 30</td>
              <td>{{ calcData.employer_match.tiers[3].yos_upper_limit }}</td>
            </tr>

            <tr>
              <td>61</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 5 Matching Amount</td>
              <td>0% to 500%</td>
              <td>{{ calcData.employer_match.tiers[4].matching_amount }}%</td>
            </tr>
            <tr>
              <td>62</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 5 Deferral Rate</td>
              <td>0% to 15%</td>
              <td>{{ calcData.employer_match.tiers[4].deferral_rate }}%</td>
            </tr>
            <tr>
              <td>63</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 5 Contribution Amount</td>
              <td>up to $18,500</td>
              <td>
                {{
                  calcData.employer_match.tiers[4].contribution_amount
                    | currency
                }}
              </td>
            </tr>
            <tr>
              <td>64</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Tier 5 YOS Upper Limit</td>
              <td><= 30</td>
              <td>{{ calcData.employer_match.tiers[4].yos_upper_limit }}</td>
            </tr>

            <tr>
              <td>65</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Dollar Limit</td>
              <td>Yes or No</td>
              <td>{{ calcData.employer_match.dollar_limit }}</td>
            </tr>
            <tr>
              <td>66</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Dollar Limit Amount</td>
              <td>
                Maximum Match Dollar amount but no more than Annual DC limit
              </td>
              <td>
                {{ calcData.employer_match.dollar_limit_amount | currency }}
              </td>
            </tr>
            <tr>
              <td>67</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Catch-Up Contribution Matched</td>
              <td>Yes or No</td>
              <td>{{ calcData.employer_match.catch_up_matched }}</td>
            </tr>
            <tr>
              <td>68</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Match</td>
              <td>ER Match Funding Frequency</td>
              <td>With Payroll, Monthly, Quarterly, Semi-Annual or EOY</td>
              <td>{{ calcData.employer_match.funding_frequency }}</td>
            </tr>
            <tr>
              <td>69</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Other</td>
              <td>ER Other</td>
              <td>
                0 if No, 1 if percent, 2 if percent with limit, 3 if $, 4 if SSI
              </td>
              <td>{{ calcData.employer_other.er_other }}</td>
            </tr>
            <tr>
              <td>70</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Other</td>
              <td>ER Other Age Requirement Years</td>
              <td>Between 0 and 21</td>
              <td>
                {{ calcData.employer_other.req_age_years | numeral("0.2") }}
              </td>
            </tr>

            <tr>
              <td>71</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Other</td>
              <td>ER Other Age Requirement Months</td>
              <td>Between 0 and 12</td>
              <td>
                {{ calcData.employer_other.req_age_months | numeral("0.2") }}
              </td>
            </tr>

            <tr>
              <td>72</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Other</td>
              <td>ER Other Service Requirement Years</td>
              <td>0, 1 or 2</td>
              <td>
                {{ calcData.employer_other.req_service_years | numeral("0.2") }}
              </td>
            </tr>

            <tr>
              <td>73</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Other</td>
              <td>ER Other Service Requirement Months</td>
              <td>0 to 12</td>
              <td>
                {{
                  calcData.employer_other.req_service_months | numeral("0.2")
                }}
              </td>
            </tr>

            <tr>
              <td>74</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Other</td>
              <td>ER Other Percent of Compensation</td>
              <td>0% to 25%</td>
              <td>{{ calcData.employer_other.compensation_percent }}%</td>
            </tr>

            <tr>
              <td>75</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Other</td>
              <td>ER Other Dollar Limit</td>
              <td>Yes or No</td>
              <td>{{ calcData.employer_other.dollar_limit }}</td>
            </tr>

            <tr>
              <td>76</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Other</td>
              <td>ER Other Dollar Limit Amount</td>
              <td>
                Maximum Other Dollar amount but no more than Annual DC limit
              </td>
              <td>
                {{ calcData.employer_other.dollar_limit_amount | currency }}
              </td>
            </tr>

            <tr>
              <td>77</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Other</td>
              <td>ER Other Flat Dollar Amount</td>
              <td>$0 to 415 limit</td>
              <td>
                {{ calcData.employer_other.flat_dollar_limit | currency }}
              </td>
            </tr>

            <tr>
              <td>78</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Other</td>
              <td>ER Other SSI - % of comp below level</td>
              <td>0% to 15%</td>
              <td>{{ calcData.employer_other.compensation_below_lvl }}%</td>
            </tr>

            <tr>
              <td>79</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Other</td>
              <td>ER Other SSI - compensation amount</td>
              <td>less than taxable wage base</td>
              <td>
                {{ calcData.employer_other.compensation_amount | currency }}
              </td>
            </tr>

            <tr>
              <td>80</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Other</td>
              <td>ER Other SSI - % of comp above level</td>
              <td>IRS based</td>
              <td>{{ calcData.employer_other.compensation_above_lvl }}%</td>
            </tr>

            <tr>
              <td>81</td>
              <td>roe_savings_plan_design</td>
              <td>Employer Other</td>
              <td>ER Other Funding Frequency</td>
              <td>With Payroll, Monthly, Quarterly, Semi-Annual or EOY</td>
              <td>{{ calcData.employer_other.funding_frequency }}</td>
            </tr>

            <tr class="yellow">
              <td>82</td>
              <td>part_data_from_rk_static</td>
              <td>Participant Basic Data</td>
              <td>social_security_number</td>
              <td>Not needed although FBi is SOC2 certified</td>
              <td>{{ calcData.participant.social_security_number }}</td>
            </tr>

            <tr class="yellow">
              <td>83</td>
              <td>part_data_from_rk_static</td>
              <td>Participant Basic Data</td>
              <td>participant_identifier</td>
              <td>redacted 128 bit encrypted identifier of participant</td>
              <td>{{ calcData.participant.participant_identifier }}</td>
            </tr>

            <tr class="yellow">
              <td>84</td>
              <td>part_data_from_rk_static</td>
              <td>Participant Basic Data</td>
              <td>first_name</td>
              <td>Not needed although FBi is SOC2 certified</td>
              <td>{{ calcData.participant.first_name }}</td>
            </tr>

            <tr class="yellow">
              <td>85</td>
              <td>part_data_from_rk_static</td>
              <td>Participant Basic Data</td>
              <td>last_name</td>
              <td>Not needed although FBi is SOC2 certified</td>
              <td>{{ calcData.participant.last_name }}</td>
            </tr>

            <tr class="yellow">
              <td>86</td>
              <td>part_data_from_rk_static</td>
              <td>Participant Basic Data</td>
              <td>work_email_address</td>
              <td>Not needed although FBi is SOC2 certified</td>
              <td>{{ calcData.participant.work_email_address }}</td>
            </tr>

            <tr class="yellow">
              <td>87</td>
              <td>part_data_from_rk_static</td>
              <td>Participant Basic Data</td>
              <td>personal_email_address</td>
              <td>Not needed although FBi is SOC2 certified</td>
              <td>{{ calcData.participant.personal_email_address }}</td>
            </tr>

            <tr class="yellow">
              <td>88</td>
              <td>part_data_from_rk_static</td>
              <td>Participant Basic Data</td>
              <td>address_1</td>
              <td>Not needed although FBi is SOC2 certified</td>
              <td>{{ calcData.participant.address_1 }}</td>
            </tr>

            <tr class="yellow">
              <td>89</td>
              <td>part_data_from_rk_static</td>
              <td>Participant Basic Data</td>
              <td>address_2</td>
              <td>Not needed although FBi is SOC2 certified</td>
              <td>{{ calcData.participant.address_2 }}</td>
            </tr>

            <tr class="yellow">
              <td>90</td>
              <td>part_data_from_rk_static</td>
              <td>Participant Basic Data</td>
              <td>city</td>
              <td>Not needed although FBi is SOC2 certified</td>
              <td>{{ calcData.participant.city }}</td>
            </tr>

            <tr>
              <td>91</td>
              <td>part_data_from_rk_static</td>
              <td>Participant Basic Data</td>
              <td>state_residence_code</td>
              <td>
                Not needed although FBi is SOC2 certified - limit this to 50
                states plus DC and PR
              </td>
              <td>{{ calcData.participant.state_residence_code }}</td>
            </tr>

            <tr class="yellow">
              <td>92</td>
              <td>part_data_from_rk_static</td>
              <td>Participant Basic Data</td>
              <td>zip_code_id</td>
              <td>
                Not needed although FBi is SOC2 certified - valid US zip codes
              </td>
              <td>{{ calcData.participant.zip_code_id }}</td>
            </tr>

            <tr>
              <td>93</td>
              <td>part_data_from_rk_static</td>
              <td>Participant Basic Data</td>
              <td>birth_date</td>
              <td>At least 16 years before today's date</td>
              <td>
                {{ calcData.participant.birth_date | dateFormat("MM/D/YYYY") }}
              </td>
            </tr>

            <tr>
              <td>94</td>
              <td>part_data_from_rk_static</td>
              <td>Participant Basic Data</td>
              <td>hire_date</td>
              <td>At least 16 years after DOB</td>
              <td>
                {{ calcData.participant.hire_date | dateFormat("MM/D/YYYY") }}
              </td>
            </tr>

            <tr class="yellow">
              <td>95</td>
              <td>part_data_from_rk_static</td>
              <td>Participant Basic Data</td>
              <td>termination_date</td>
              <td>after hire date</td>
              <td v-if="calcData.participant.termination_date">
                {{
                  calcData.participant.termination_date
                    | dateFormat("MM/D/YYYY")
                }}
              </td>
            </tr>

            <tr>
              <td>96</td>
              <td>part_data_from_rk_static</td>
              <td>Participant Basic Data</td>
              <td>estimated_annual_wages</td>
              <td>$ amount with no decimals</td>
              <td>
                {{ calcData.participant.estimated_annual_wages | currency }}
              </td>
            </tr>

            <tr class="yellow">
              <td>97</td>
              <td>part_data_from_rk_static</td>
              <td>Participant Basic Data</td>
              <td>hours_per_week</td>
              <td>40 or less</td>
              <td>{{ calcData.participant.hours_per_week }}</td>
            </tr>

            <tr>
              <td>98</td>
              <td>part_data_from_rk_static</td>
              <td>Participant Basic Data</td>
              <td>gender</td>
              <td>M or F</td>
              <td>{{ calcData.participant.gender }}</td>
            </tr>

            <tr>
              <td>99</td>
              <td>part_data_from_rk_static</td>
              <td>Participant Basic Data</td>
              <td>marital_status</td>
              <td>Married or Single</td>
              <td>{{ calcData.participant.marital_status }}</td>
            </tr>

            <tr>
              <td>100</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Balances</td>
              <td>pre-tax balance</td>
              <td>
                Summarized by all funds - must be greater than or equal to zero
              </td>
              <td>{{ calcData.participant_balance.pre_tax | currency }}</td>
            </tr>

            <tr>
              <td>101</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Balances</td>
              <td>roth balance</td>
              <td>
                Summarized by all funds - must be greater than or equal to zero
              </td>
              <td>{{ calcData.participant_balance.roth | currency }}</td>
            </tr>

            <tr>
              <td>102</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Balances</td>
              <td>post-tax balance</td>
              <td>
                Summarized by all funds - must be greater than or equal to zero
              </td>
              <td>{{ calcData.participant_balance.post_tax | currency }}</td>
            </tr>
            <tr>
              <td>103</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Balances</td>
              <td>post-tax balance contribution basis</td>
              <td>
                Summarized by all funds - must be greater than or equal to zero
              </td>
              <td>
                {{ calcData.participant_balance.post_tax_basic | currency }}
              </td>
            </tr>
            <tr>
              <td>104</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Balances</td>
              <td>rollover balance</td>
              <td>
                Summarized by all funds - must be greater than or equal to zero
              </td>
              <td>{{ calcData.participant_balance.rollover | currency }}</td>
            </tr>
            <tr>
              <td>105</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Balances</td>
              <td>er match balance</td>
              <td>
                Summarized by all funds - must be greater than or equal to zero
              </td>
              <td>{{ calcData.participant_balance.er_match | currency }}</td>
            </tr>
            <tr>
              <td>106</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Balances</td>
              <td>er other balance</td>
              <td>
                Summarized by all funds - must be greater than or equal to zero
              </td>
              <td>{{ calcData.participant_balance.er_other | currency }}</td>
            </tr>

            <tr>
              <td>107</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>pre_tax_deferral_ytd_dollars</td>
              <td><= $18500</td>
              <td>
                {{ calcData.pre_tax_contribution.ytd_dollars | currency }}
              </td>
            </tr>

            <tr>
              <td>108</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>pre_tax_deferral_percent</td>
              <td><= plan maximum</td>
              <td>{{ calcData.pre_tax_contribution.percent }}%</td>
            </tr>

            <tr>
              <td>109</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>pre_tax_deferral_dollars</td>
              <td>translated to percent must be <-plan maximum</td>
              <td>{{ calcData.pre_tax_contribution.dollars | currency }}</td>
            </tr>

            <tr>
              <td>110</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>pre_tax_deferral_dollars_frequency</td>
              <td>
                52 (weekly), 26 (bi-weekly), 24 (semi-monthly), 12 (monthly)
              </td>
              <td>{{ calcData.pre_tax_contribution.dollars_frequency }}</td>
            </tr>

            <tr>
              <td>111</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>pre_tax_deferral_ytd_catchup_dollars</td>
              <td><= $6000</td>
              <td>
                {{
                  calcData.pre_tax_contribution.ytd_catchup_dollars | currency
                }}
              </td>
            </tr>

            <tr>
              <td>112</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>pre_tax_deferral_percent_catchup</td>
              <td>will be limited to $6,000</td>
              <td>
                {{ calcData.pre_tax_contribution.percent_catchup | currency }}
              </td>
            </tr>

            <tr>
              <td>113</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>pre_tax_deferral_dollars_catchup</td>
              <td>will be limited to $6,000</td>
              <td>
                {{ calcData.pre_tax_contribution.dollars_catchup | currency }}
              </td>
            </tr>

            <tr>
              <td>114</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>pre_tax_deferral_dollars_catchup_frequency</td>
              <td>equal to whatever pre-tax frequency is</td>
              <td>
                {{ calcData.pre_tax_contribution.dollars_catchup_frequency }}
              </td>
            </tr>

            <tr>
              <td>115</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>ee_chosen_auto_enroll_opt_out_pre_tax</td>
              <td>Yes or No</td>
              <td>{{ calcData.pre_tax_contribution.opt_out }}</td>
            </tr>

            <tr>
              <td>116</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>ee_chosen_auto_escalate_frequency_type_pre_tax</td>
              <td>
                Annual change A = 1/1, P = 1st of Plan Year, H = Hire date, E =
                Elig Date and S for Semi-Annual
              </td>
              <td>{{ calcData.pre_tax_contribution.frequency_type }}</td>
            </tr>

            <tr>
              <td>117</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>ee_chosen_auto_escalate_annual_pre_tax_percent</td>
              <td>1% to 5%</td>
              <td>{{ calcData.pre_tax_contribution.annual_percent }}%</td>
            </tr>

            <tr>
              <td>118</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>ee_chosen_auto_escalate_maximum_pre_tax_percent</td>
              <td>0% to plan maximum</td>
              <td>{{ calcData.pre_tax_contribution.maximum_percent }}%</td>
            </tr>

            <tr>
              <td>119</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>ee_chosen_auto_escalate_frequency1_pre_tax</td>
              <td>Date Effective</td>
              <td>{{ calcData.pre_tax_contribution.frequency1 }}</td>
            </tr>

            <tr>
              <td>120</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>ee_chosen_auto_escalate_frequency2_pre_tax</td>
              <td>Date Effective</td>
              <td>{{ calcData.pre_tax_contribution.frequency2 }}</td>
            </tr>

            <tr>
              <td>121</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>roth_deferral_ytd_dollars</td>
              <td><= $18500</td>
              <td>{{ calcData.roth_contribution.ytd_dollars | currency }}</td>
            </tr>

            <tr>
              <td>122</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>roth_deferral_percent</td>
              <td><= plan maximum</td>
              <td>{{ calcData.roth_contribution.percent }}%</td>
            </tr>

            <tr>
              <td>123</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>roth_deferral_dollars</td>
              <td>translated to percent must be <- plan maximum</td>
              <td>{{ calcData.roth_contribution.dollars | currency }}</td>
            </tr>

            <tr>
              <td>124</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>roth_deferral_dollars_frequency</td>
              <td>
                52 (weekly), 26 (bi-weekly), 24 (semi-monthly), 12 (monthly)
              </td>
              <td>{{ calcData.roth_contribution.dollars_frequency }}</td>
            </tr>

            <tr>
              <td>125</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>roth_deferral_ytd_catchup_dollars</td>
              <td><= $6000</td>
              <td>
                {{ calcData.roth_contribution.ytd_catchup_dollars | currency }}
              </td>
            </tr>

            <tr>
              <td>126</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>roth_deferral_percent_catchup</td>
              <td>will be limited to $6,000</td>
              <td>{{ calcData.roth_contribution.percent_catchup }}%</td>
            </tr>

            <tr>
              <td>127</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>roth_deferral_dollars_catchup</td>
              <td>will be limited to $6,000</td>
              <td>
                {{ calcData.roth_contribution.dollars_catchup | currency }}
              </td>
            </tr>

            <tr>
              <td>128</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>roth_deferral_dollars_catchup_frequency</td>
              <td>equal to whatever pre-tax frequency is</td>
              <td>
                {{ calcData.roth_contribution.dollars_catchup_frequency }}
              </td>
            </tr>

            <tr>
              <td>129</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>ee_chosen_auto_enroll_opt_out_roth</td>
              <td>Yes or No</td>
              <td>{{ calcData.roth_contribution.opt_out }}</td>
            </tr>

            <tr>
              <td>130</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>ee_chosen_auto_escalate_frequency_type_roth</td>
              <td>
                Annual change A = 1/1, P = 1st of Plan Year, H = Hire date, E =
                Elig Date and S for Semi-Annual
              </td>
              <td>{{ calcData.roth_contribution.frequency_type }}</td>
            </tr>

            <tr>
              <td>131</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>ee_chosen_auto_escalate_annual_roth_percent</td>
              <td>1% to 5%</td>
              <td>{{ calcData.roth_contribution.annual_percent }}%</td>
            </tr>

            <tr>
              <td>132</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>ee_chosen_auto_escalate_maximum_roth_percent</td>
              <td>0% to plan maximum</td>
              <td>{{ calcData.roth_contribution.maximum_percent }}%</td>
            </tr>
            <tr>
              <td>133</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>ee_chosen_auto_escalate_frequency1_roth</td>
              <td>Date Effective</td>
              <td>{{ calcData.roth_contribution.frequency1 }}</td>
            </tr>

            <tr>
              <td>134</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>ee_chosen_auto_escalate_frequency2_roth</td>
              <td>Date Effective</td>
              <td>{{ calcData.roth_contribution.frequency2 }}</td>
            </tr>

            <tr>
              <td>135</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>post_tax_deferral_ytd_dollars</td>
              <td><=55000</td>
              <td>
                {{ calcData.post_tax_contribution.ytd_dollars | currency }}
              </td>
            </tr>

            <tr class="yellow">
              <td>136</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>post_tax_deferral_percent</td>
              <td><= plan maximum</td>
              <td>{{ calcData.post_tax_contribution.percent }}%</td>
            </tr>

            <tr>
              <td>137</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>post_tax_deferral_dollars</td>
              <td><= plan maximum</td>
              <td>{{ calcData.post_tax_contribution.dollars | currency }}</td>
            </tr>

            <tr>
              <td>138</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>post_tax_deferral_dollars_frequency</td>
              <td>
                52 (weekly), 26 (bi-weekly), 24 (semi-monthly), 12 (monthly)
              </td>
              <td>{{ calcData.post_tax_contribution.dollars_frequency }}</td>
            </tr>

            <tr class="yellow">
              <td>139</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>er_matching_contribution_ytd_dollars</td>
              <td><=$55,000</td>
              <td>
                {{ calcData.er_matching_contribution_ytd_dollars | currency }}
              </td>
            </tr>

            <tr class="yellow">
              <td>140</td>
              <td>part_data_from_rk_dynamic</td>
              <td>Participant Contributions</td>
              <td>er_other_contribution_ytd_dollars</td>
              <td><=$55,000</td>
              <td>
                {{ calcData.er_other_contribution_ytd_dollars | currency }}
              </td>
            </tr>

            <tr>
              <td>140.1</td>
              <td>part_data_from_part_ldi_dynamic</td>
              <td>Retirement Income</td>
              <td>desired_retirement_income_date</td>
              <td>
                Date individual wants to retire - if nothing, it will equal the
                Social Security NRA
              </td>
              <td>
                Year: {{ calcData.participant.drd_year }}, Month:
                {{ calcData.participant.drd_month }}
              </td>
            </tr>

            <tr>
              <td>141</td>
              <td>part_data_from_part_ldi_dynamic</td>
              <td>Retirement Income</td>
              <td>desired_retirement_income_amount</td>
              <td>
                Income individual wishes to have at retirement - if nothing, use
                the DFA Wage Replacement Data
              </td>
              <td>{{ calcData.participant.drd_income }}</td>
            </tr>

            <tr>
              <td>142</td>
              <td>part_data_from_part_ldi_dynamic</td>
              <td>Retirement Income</td>
              <td>desired_retirement_state</td>
              <td>Must be 1 of 50 states plus Wash DC and Puerto Rico</td>
              <td>{{ calcData.participant.drd_state }}</td>
            </tr>

            <tr>
              <td>143</td>
              <td>part_data_from_part_ldi_dynamic</td>
              <td>Participant Other Balances</td>
              <td>other_pre_tax_balances</td>
              <td>Must be greater than or equal to zero</td>
              <td>
                {{ calcData.participant_balance.other_pre_tax | currency }}
              </td>
            </tr>

            <tr>
              <td>144</td>
              <td>part_data_from_part_ldi_dynamic</td>
              <td>Participant Other Balances</td>
              <td>other_roth_balances</td>
              <td>Must be greater than or equal to zero</td>
              <td>{{ calcData.participant_balance.other_roth | currency }}</td>
            </tr>

            <tr>
              <td>145</td>
              <td>part_data_from_part_ldi_dynamic</td>
              <td>Participant Other Balances</td>
              <td>other_post_tax_balances</td>
              <td>Must be greater than or equal to zero</td>
              <td>
                {{ calcData.participant_balance.other_post_tax | currency }}
              </td>
            </tr>

            <tr class="yellow">
              <td>146</td>
              <td>part_data_from_part_ldi_dynamic</td>
              <td>Participant Part Time Income</td>
              <td>part_time_income_amount_exists</td>
              <td>Yes or No</td>
              <td>{{ calcData.participant_part_time_income.amount_exists }}</td>
            </tr>

            <tr class="yellow">
              <td>147</td>
              <td>part_data_from_part_ldi_dynamic</td>
              <td>Participant Part Time Income</td>
              <td>part_time_income_start_age</td>
              <td></td>
              <td>{{ calcData.participant_part_time_income.start_age }}</td>
            </tr>

            <tr class="yellow">
              <td>148</td>
              <td>part_data_from_part_ldi_dynamic</td>
              <td>Participant Part Time Income</td>
              <td>part_time_income_end_age</td>
              <td></td>
              <td>{{ calcData.participant_part_time_income.end_age }}</td>
            </tr>

            <tr class="yellow">
              <td>149</td>
              <td>part_data_from_part_ldi_dynamic</td>
              <td>Participant Part Time Income</td>
              <td>part_time_income_monthly_amount</td>
              <td></td>
              <td>
                {{
                  calcData.participant_part_time_income.monthly_amount
                    | currency
                }}
              </td>
            </tr>

            <tr>
              <td>150</td>
              <td>part_data_from_part_ldi_dynamic</td>
              <td>Participant Pension</td>
              <td>other_pension_month</td>
              <td>Accrued Benefit at NRA</td>
              <td>{{ calcData.participant.pension | currency }}</td>
            </tr>

            <tr>
              <td>151</td>
              <td>part_data_from_plan_sponsor_dynamic</td>
              <td>Sponsor NQDC</td>
              <td>nqdc_deferral_ytd</td>
              <td></td>
              <td>{{ calcData.nqdc.ytd_dollars | currency }}</td>
            </tr>
            <tr>
              <td>152</td>
              <td>part_data_from_plan_sponsor_dynamic</td>
              <td>Sponsor NQDC</td>
              <td>nqdc_deferral_percent</td>
              <td><= 100%</td>
              <td>{{ calcData.nqdc.percent }}%</td>
            </tr>
            <tr>
              <td>153</td>
              <td>part_data_from_plan_sponsor_dynamic</td>
              <td>Sponsor NQDC</td>
              <td>nqdc_deferral_dollars</td>
              <td></td>
              <td>{{ calcData.nqdc.dollars | currency }}</td>
            </tr>
            <tr>
              <td>154</td>
              <td>part_data_from_plan_sponsor_dynamic</td>
              <td>Sponsor NQDC</td>
              <td>nqdc_deferral_dollars_frequency</td>
              <td>
                52 (weekly), 26 (bi-weekly), 24 (semi-monthly), 12 (monthly)
              </td>
              <td>{{ calcData.nqdc.dollars_frequency }}</td>
            </tr>
            <tr>
              <td>155</td>
              <td>part_data_from_plan_sponsor_dynamic</td>
              <td>Sponsor NQDC</td>
              <td>nqdc_balance</td>
              <td>Beginning Balance of NQDC plan</td>
              <td>{{ calcData.nqdc.balance | currency }}</td>
            </tr>
            <tr>
              <td>156</td>
              <td>part_data_from_plan_sponsor_dynamic</td>
              <td>Sponsor Pension</td>
              <td>sponsor_db_plan_monthly_benefit</td>
              <td>Accrued Benefit at NRA</td>
              <td>{{ calcData.nqdc.pension | currency }}</td>
            </tr>

            <tr class="yellow">
              <td>157</td>
              <td>part_data_from_mstar_dynamic</td>
              <td>Participant Rate of Return</td>
              <td>mstar_current_rate_of_return_pre-tax</td>
              <td>From Mstar wealth engine…will be between 0% and 10%</td>
              <td>5.73%</td>
            </tr>

            <tr class="yellow">
              <td>158</td>
              <td>part_data_from_mstar_dynamic</td>
              <td>Participant Rate of Return</td>
              <td>mstar_current_rate_of_return_roth</td>
              <td>From Mstar wealth engine…will be between 0% and 10%</td>
              <td>5.76%</td>
            </tr>

            <tr class="yellow">
              <td>159</td>
              <td>part_data_from_mstar_dynamic</td>
              <td>Participant Rate of Return</td>
              <td>mstar_current_rate_of_return_after-tax</td>
              <td>From Mstar wealth engine…will be between 0% and 10%</td>
              <td>5.81%</td>
            </tr>

            <tr class="yellow">
              <td>160</td>
              <td>part_data_from_mstar_dynamic</td>
              <td>Participant Rate of Return</td>
              <td>mstar_current_rate_of_return_er_matching</td>
              <td>From Mstar wealth engine…will be between 0% and 10%</td>
              <td>5.82%</td>
            </tr>

            <tr class="yellow">
              <td>161</td>
              <td>part_data_from_mstar_dynamic</td>
              <td>Participant Rate of Return</td>
              <td>mstar_current_rate_of_return_er_profit_sharing</td>
              <td>From Mstar wealth engine…will be between 0% and 10%</td>
              <td>5.90%</td>
            </tr>

            <tr class="yellow">
              <td>162</td>
              <td>part_data_from_mstar_dynamic</td>
              <td>Participant Rate of Return</td>
              <td>mstar_current_rate_of_return_rollover</td>
              <td>From Mstar wealth engine…will be between 0% and 10%</td>
              <td>5.86%</td>
            </tr>

            <tr class="yellow">
              <td>163</td>
              <td>part_data_from_mstar_dynamic</td>
              <td>Participant Rate of Return</td>
              <td>mstar_current_rate_of_return_nqdc</td>
              <td>From Mstar wealth engine…will be between 0% and 10%</td>
              <td>5.70%</td>
            </tr>

            <tr class="yellow">
              <td>164</td>
              <td>part_data_from_mstar_dynamic</td>
              <td>Participant Rate of Return</td>
              <td>mstar_recommended_rate_of_return_pre-tax</td>
              <td>From Mstar wealth engine…will be between 0% and 10%</td>
              <td>7.23%</td>
            </tr>

            <tr class="yellow">
              <td>165</td>
              <td>part_data_from_mstar_dynamic</td>
              <td>Participant Rate of Return</td>
              <td>mstar_recommended_rate_of_return_roth</td>
              <td>From Mstar wealth engine…will be between 0% and 10%</td>
              <td>7.26%</td>
            </tr>

            <tr class="yellow">
              <td>166</td>
              <td>part_data_from_mstar_dynamic</td>
              <td>Participant Rate of Return</td>
              <td>mstar_recommended_rate_of_return_after-tax</td>
              <td>From Mstar wealth engine…will be between 0% and 10%</td>
              <td>7.31%</td>
            </tr>

            <tr class="yellow">
              <td>167</td>
              <td>part_data_from_mstar_dynamic</td>
              <td>Participant Rate of Return</td>
              <td>mstar_recommended_rate_of_return_er_matching</td>
              <td>From Mstar wealth engine…will be between 0% and 10%</td>
              <td>7.32%</td>
            </tr>

            <tr class="yellow">
              <td>168</td>
              <td>part_data_from_mstar_dynamic</td>
              <td>Participant Rate of Return</td>
              <td>mstar_recommended_rate_of_return_er_profit_sharing</td>
              <td>From Mstar wealth engine…will be between 0% and 10%</td>
              <td>7.40%</td>
            </tr>

            <tr class="yellow">
              <td>169</td>
              <td>part_data_from_mstar_dynamic</td>
              <td>Participant Rate of Return</td>
              <td>mstar_recommended_rate_of_return_rollover</td>
              <td>From Mstar wealth engine…will be between 0% and 10%</td>
              <td>7.36%</td>
            </tr>

            <tr class="yellow">
              <td>170</td>
              <td>part_data_from_mstar_dynamic</td>
              <td>Participant Rate of Return</td>
              <td>mstar_recommended_rate_of_return_nqdc</td>
              <td>From Mstar wealth engine…will be between 0% and 10%</td>
              <td>7.20%</td>
            </tr>
          </table>
        </md-content>
      </md-content>
    </div>
  </div>
</template>
<style scoped src="bootstrap/dist/css/bootstrap.min.css"></style>

<script>
import RoeCalcInputFields from "@/components/calculators/InputFields";
import store from "@/store";
import { mapGetters } from "vuex";
import { CALC_INPUT_FIELDS, CALC_RESET_STATE } from "@/store/actions.type";
import { INPUT_TYPES } from "@/store/calculatorInputs.type";
import "vue-material/dist/vue-material.css";
import "vue-material/dist/theme/default.css";

export default {
  data() {
    return {
      calcAction: CALC_INPUT_FIELDS,
      inputCategories: [
        INPUT_TYPES.PARTICIPANT_BALANCE,
        INPUT_TYPES.PARTICIPANT,
        INPUT_TYPES.PLAN_BASIC_DATA,
        INPUT_TYPES.AUTO_ENROLLMENT,
        INPUT_TYPES.AUTO_INCREASE,
        INPUT_TYPES.EMPLOYEE_CONTRIBUTION,
        INPUT_TYPES.EMPLOYEE_MATCH,
        INPUT_TYPES.EMPLOYEE_OTHER,
        INPUT_TYPES.PRE_TAX_CONTRIBUTION,
        INPUT_TYPES.ROTH_CONTRIBUTION,
        INPUT_TYPES.POST_TAX_CONTRIBUTION,
        INPUT_TYPES.NQDC_CONTRIBUTION,
        INPUT_TYPES.COMPLIANCE_LIMIT
      ]
    };
  },
  components: { RoeCalcInputFields },
  computed: {
    ...mapGetters(["calcData"])
  },
  async beforeRouteEnter(to, from, next) {
    await store.dispatch(CALC_RESET_STATE);
    return next();
  }
};
</script>
